import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ProductosService } from '../../services/productos.service';
import { LowStockSheetComponent } from './low-stock-sheet.component';

const LOW_STOCK_THRESHOLD = 3;

@Component({
  selector: 'app-low-stock-notification',
  template: `
    <button mat-icon-button
            [matBadge]="badgeCount || null"
            matBadgeColor="warn"
            matBadgeSize="small"
            (click)="openSheet()"
            matTooltip="Stock bajo">
      <mat-icon [class.warn-icon]="badgeCount > 0">warning_amber</mat-icon>
    </button>
  `,
  styles: [`.warn-icon { color: #f44336; }`]
})
export class LowStockNotificationComponent implements OnInit {
  badgeCount = 0;
  private lowStockProducts: any[] = [];

  constructor(
    private productosService: ProductosService,
    private bottomSheet: MatBottomSheet
  ) {}

  ngOnInit(): void {
    this.checkLowStock();
  }

  checkLowStock(): void {
    this.productosService.get().subscribe({
      next: (response: any) => {
        const products = Array.isArray(response) ? response : (response?.data || []);
        this.lowStockProducts = products.filter(
          (p: any) => Number(p.stock) <= LOW_STOCK_THRESHOLD
        );
        this.badgeCount = this.lowStockProducts.length;
      },
      error: () => {
        this.lowStockProducts = [];
        this.badgeCount = 0;
      }
    });
  }

  openSheet(): void {
    this.bottomSheet.open(LowStockSheetComponent, {
      data: { products: this.lowStockProducts }
    });
  }
}
